import moment from "moment";

const CREATED_OR_BLANK = "Z05";
const ENTERED_NOT_PROCESSED = "Z10";

const NEW_CODES = ["Z05"];
const PENDING_CODES = ["Z10"];
const APPROVED_CODES = ["Z40", "Z50", "Z30"];
const HIDDEN_CODES = ["Z99", "Z12"];

// eslint-disable-next-line
export const isInEditableState = (ts) =>
  ts.calculatedStatusCode === CREATED_OR_BLANK ||
  ts.calculatedStatusCode === ENTERED_NOT_PROCESSED;

export const checkIfHidden = (statusCode) => HIDDEN_CODES.includes(statusCode);

export const getStatusName = (statusCode, isRejected, submitted) => {
  if (PENDING_CODES.includes(statusCode) && isRejected) {
    return "rejected";
  }

  if (PENDING_CODES.includes(statusCode) && submitted) {
    return "pending";
  }
  if (PENDING_CODES.includes(statusCode) && !submitted) {
    return "incomplete";
  }
  if (NEW_CODES.includes(statusCode)) {
    return "new";
  }
  if (APPROVED_CODES.includes(statusCode)) {
    return "approved";
  }

  return "";
};

export const getDateWithOffset = (startDate, daysOffset) => {
  const newDate = new Date(startDate.valueOf());
  newDate.setDate(newDate.getDate() + daysOffset);
  return newDate;
};

export const displayTimesheetDate = (startDate, daysOffset) => {
  return moment(getDateWithOffset(startDate, daysOffset)).format("DD/MM/YY");
};

export const TimesheetStatus = Object.freeze({
  Loading: 1,
  Failed: 2,
  Success: 3,
  Empty: 4,
});
